<template>
<div class="pdf-preview">
  <div class="pdf-preview-loader">
    <BaseLoader />
  </div>
  <div class="pdf-preview__content">
    <div class="pdf-preview__card-wrapper">
      <div class="pdf-preview__card" ref="reportSummary1">
        <reportSummary1 :project="project" :report="report"/>
      </div>
    </div>
    <div class="pdf-preview__card-wrapper">
      <div class="pdf-preview__card" ref="reportSummary2">
        <reportSummary2 :project="project" :report="report"/>
      </div>
    </div>
    <div class="pdf-preview__card-wrapper">
      <div class="pdf-preview__card" ref="reportSummary3">
        <reportSummary3 />
      </div>
    </div>
    <div class="pdf-preview__card-wrapper">
      <div class="pdf-preview__card" ref="reportHeatmap">
        <reportHeatmap />
      </div>
    </div>
    <div class="pdf-preview__card-wrapper">
      <div class="pdf-preview__card" ref="reportDescription">
        <reportDescription />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import html2canvas from "html2canvas"
import jsPDF from "jspdf";
import reportSummary1 from './report-summary-1';
import reportSummary2 from './report-summary-2';
import reportSummary3 from './report-summary-3';
import reportDescription from './report-description';
import reportHeatmap from './report-heatmap';
import BaseLoader from '../../components/BaseLoader';

export default {
  name: "index",
  props: ['name', 'report', 'project'],
  components: {
    reportSummary1,
    reportSummary2,
    reportSummary3,
    reportDescription,
    reportHeatmap,
    BaseLoader
  },
  data() {
    return {
      doc: null,
      images: []
    }
  },
  mounted() {
    this.doc = new jsPDF();
    setTimeout(() => {
      this.printFullReport();

    }, 3000);
  },
  methods: {
    async printFullReport() {
      // FIXME
      html2canvas(this.$refs.reportSummary1).then((canvas) => {
        const img = canvas.toDataURL("image/png");

        this.doc.addImage(img, 'PNG', 5, 2, 205, 295, '1', 'NONE');
        this.doc.addPage();

        html2canvas(this.$refs.reportSummary2).then((canvas) => {
          const img = canvas.toDataURL("image/png");

          this.doc.addImage(img, 'PNG', 5, 2, 205, 295, '2', 'NONE');
          this.doc.addPage();

          // html2canvas(this.$refs.reportSummary3).then((canvas) => {
          //   const img = canvas.toDataURL("image/png");
          //
          //   this.doc.addImage(img, 'PNG', 5, 2, 205, 295, '3', 'NONE');
          //   this.doc.addPage();
          //
          //   html2canvas(this.$refs.reportHeatmap).then((canvas) => {
          //     const img = canvas.toDataURL("image/png");
          //
          //     this.doc.addImage(img, 'PNG', 5, 2, 205, 295, '4', 'NONE');
          //     this.doc.addPage();

              html2canvas(this.$refs.reportDescription).then((canvas) => {
                const img = canvas.toDataURL("image/png");

                this.doc.addImage(img, 'PNG', 5, 2, 205, 295, '5', 'NONE');
                this.doc.save(this.name);

                this.$emit('generated');
              });
            });
          });
      //   });
      //
      // });
    },
  }
}
</script>
